export const themeToggleStyles = {
  trigger:
    'text-fg-secondary hover:text-fg-primary hover:bg-bg-subtle inline-flex h-11 w-11 items-center justify-center rounded-md transition-colors duration-fast ease-token',
  triggerIcon: 'h-5 w-5',
} as const;
